import React from "react";
import "./competency-card.css";

function CompetencyCard({ item }) {
  return (
    <div className="competency-card">
      <div className="competency-icon">{item.icon}</div>
      <div className="competency-content">
        <label className="competency-title">{item.title}</label>
        <p className="competency-detail">{item.detail}</p>
      </div>
    </div>
  );
}

export default CompetencyCard;
